import { render, staticRenderFns } from "./StockLocationSelect.vue?vue&type=template&id=7c7a2447"
import script from "./StockLocationSelect.vue?vue&type=script&lang=ts"
export * from "./StockLocationSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c7a2447')) {
      api.createRecord('7c7a2447', component.options)
    } else {
      api.reload('7c7a2447', component.options)
    }
    module.hot.accept("./StockLocationSelect.vue?vue&type=template&id=7c7a2447", function () {
      api.rerender('7c7a2447', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StockLocationSelect.vue"
export default component.exports